import { FC } from "react";
import { useTranslation } from "react-i18next";
import { StyledForm, StyledInput } from "./style";

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

const SearchForm: FC<Props> = ({ value, onChange, placeholder }) => {
  const { t } = useTranslation();
  return (
    <StyledForm>
      <StyledInput
        id="search"
        name="search"
        placeholder={
          placeholder || t("components.sharepoint.searchPlaceholder")
        }
        value={value}
        onChange={(e: any) => onChange(e.target.value)}
      />
    </StyledForm>
  );
};

export default SearchForm;
